/* Nividas cart bundles — behaviour for snippets/nv-cart-bundle.liquid.
   - Savings are written in SEK; shown in the customer's currency, converted
     with the storefront's active rate and the store's money format.
   The suggestion tiles are plain links: prescription tiles open the
   configurator, which builds the cart lines itself. */
(function () {
  'use strict';

  /* The collection being browsed, for "Continue shopping" after a
     prescription add (Jakob 2026-10-15: back to where they were shopping,
     else the homepage). Kept for the visit only (sessionStorage). A
     collection page keeps its filters; a product opened from a collection
     (/collections/x/products/y) records that collection. Read by
     nv-rx-configurator.js via window.nvContinueShoppingUrl(). */
  try {
    var path = location.pathname;
    var inCol = path.match(/^(\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/[^/]+)(\/products\/.*)?$/i);
    if (inCol && !/\/collections\/(all|vendors|types)$/i.test(inCol[1])) {
      if (!inCol[2]) {
        sessionStorage.setItem('nvLastCollection', path + location.search);
      } else {
        // A product opened from a collection keeps the filtered list already
        // remembered for that collection; only a different one is replaced.
        var stored = sessionStorage.getItem('nvLastCollection') || '';
        if (stored.split('?')[0] !== inCol[1]) sessionStorage.setItem('nvLastCollection', inCol[1]);
      }
    }
  } catch (e) {}
  // Filtering re-renders the collection without a page load and rewrites the
  // address; keep the remembered list in step with it.
  document.addEventListener('collection:reloaded', function () {
    try {
      if (/\/collections\/[^/]+$/i.test(location.pathname)) {
        sessionStorage.setItem('nvLastCollection', location.pathname + location.search);
      }
    } catch (e) {}
  });
  window.nvContinueShoppingUrl = function () {
    try { return sessionStorage.getItem('nvLastCollection') || '/'; } catch (e) { return '/'; }
  };

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + ' SEK';
  }

  function convert(root) {
    var cur = window.Shopify && Shopify.currency;
    var rate = cur && parseFloat(cur.rate);
    if (!rate || !cur.active || cur.active === 'SEK') return;
    (root || document).querySelectorAll('[data-nv-sek]').forEach(function (el) {
      var sek = parseInt(el.getAttribute('data-nv-sek'), 10);
      if (!isNaN(sek)) el.textContent = formatMoney(Math.round(sek * rate));
    });
  }

  var mo = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType === 1 && (n.matches('[data-nv-bundle]') || n.querySelector('[data-nv-bundle]'))) {
          convert(n);
        }
      }
    }
  });

  /* Cue: "Save 1,000 SEK on a second pair ⌄" above the cart footer while the
     offer is out of sight (same pattern as the Rx flow's scroll cue). Never
     moves the cart by itself; a tap scrolls to the offer. */
  function drawerParts() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return null;
    return {
      drawer: drawer,
      list: drawer.querySelector('.drawer__scrollable'),
      cue: drawer.querySelector('[data-nv-bundle-cue]'),
      label: drawer.querySelector('[data-nv-bundle-cue-label]'),
      offer: drawer.querySelector('[data-nv-bundle] .nividas-bundle__offer')
    };
  }

  var cueQueued = false;
  function refreshCue() {
    cueQueued = false;
    var d = drawerParts();
    if (!d || !d.cue) return;
    var html = document.documentElement;
    var show = false;
    if (d.offer && d.list && html.classList.contains('nvd') && html.classList.contains('nvb') &&
        d.drawer.classList.contains('drawer--is-open')) {
      var o = d.offer.getBoundingClientRect();
      var l = d.list.getBoundingClientRect();
      show = o.height > 0 && o.bottom > l.bottom + 4;
      // The offer's saving: an amount (converted) or a percentage.
      var amount = d.offer.querySelector('[data-nv-save]');
      // Only write when it changes: the drawer is watched for changes, and a
      // rewrite of the same text would otherwise trigger this again forever.
      var text = amount ? 'Save ' + amount.textContent.trim() + ' on a second pair' : '';
      if (d.label && text && d.label.textContent !== text) d.label.textContent = text;
    }
    if (d.cue.hidden !== !show) d.cue.hidden = !show;
  }
  function queueCue() {
    if (cueQueued) return;
    cueQueued = true;
    requestAnimationFrame(refreshCue);
  }

  var watchedList = null;
  var ro = window.ResizeObserver ? new ResizeObserver(queueCue) : null;
  function watch() {
    var d = drawerParts();
    if (!d) return;
    if (d.list && d.list !== watchedList) {
      watchedList = d.list;
      d.list.addEventListener('scroll', queueCue, { passive: true });
      if (ro) ro.observe(d.list);
    }
    if (ro && d.offer) ro.observe(d.offer);
    queueCue();
  }

  document.addEventListener('click', function (e) {
    var cue = e.target.closest && e.target.closest('[data-nv-bundle-cue]');
    if (!cue) return;
    var d = drawerParts();
    if (!d || !d.offer || !d.list) return;
    var o = d.offer.getBoundingClientRect();
    var l = d.list.getBoundingClientRect();
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    d.list.scrollBy({ top: o.bottom - l.bottom + 16, behavior: smooth ? 'smooth' : 'auto' });
  });

  function start() {
    convert(document);
    mo.observe(document.body, { childList: true, subtree: true });
    var d = drawerParts();
    if (d) {
      new MutationObserver(watch).observe(d.drawer, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    }
    window.addEventListener('resize', queueCue);
    watch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
